// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import api from "@/lib/api";

/**
 * Start the custom Google OAuth flow. Redirect URI is built from
 * window.location.origin (never hardcoded). Stores intended role in
 * sessionStorage so the callback can pass it to the backend.
 */
export async function startGoogleOAuth({ scopes, role, next } = {}) {
  const redirect_uri = window.location.origin + "/auth/google";
  if (role) sessionStorage.setItem("kb_onboarding_role", role);
  if (next) sessionStorage.setItem("kb_oauth_next", next);
  const { data } = await api.get("/auth/google/start", {
    params: { redirect_uri, scopes: scopes || undefined },
  });
  window.location.href = data.auth_url;
}

/**
 * Start an incremental-consent OAuth flow for additional scopes (Drive, Meet).
 * Returns to the page the user came from after consent.
 */
export async function requestExtraScopes(scopes) {
  return startGoogleOAuth({ scopes, next: window.location.pathname });
}
